import{useSharedValue}from'react-native-reanimated';export const useCurrentTabScrollY=()=>{return useSharedValue(0);};